module.exports = __webpack_public_path__ + "static/crm_bottom_image.fce75a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crm_bottom_image.jpg
// module id = 3069
// module chunks = 15490338360219